import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useModal } from '../contexts/ModalContext';

const ProfileCompletionWatcher = () => {
  const { currentUser, loading, shouldShowProfileCompletion } = useAuth();
  const { openProfileCompletion } = useModal();

  useEffect(() => {
    const checkAndShowModal = async () => {
      if (currentUser && !loading) {
        const shouldShow = await shouldShowProfileCompletion(currentUser.id);
        if (shouldShow) {
          // Small delay to ensure everything is ready
          setTimeout(() => {
            openProfileCompletion();
          }, 500);
        }
      }
    };

    checkAndShowModal();
  }, [currentUser, loading, shouldShowProfileCompletion, openProfileCompletion]);

  // Also check when the window gains focus (for email verification in new tab)
  useEffect(() => {
    const handleWindowFocus = async () => {
      if (currentUser && !loading) {
        const shouldShow = await shouldShowProfileCompletion(currentUser.id);
        if (shouldShow) {
          setTimeout(() => {
            openProfileCompletion();
          }, 500);
        }
      }
    };

    window.addEventListener('focus', handleWindowFocus);
    return () => window.removeEventListener('focus', handleWindowFocus);
  }, [currentUser, loading, shouldShowProfileCompletion, openProfileCompletion]);

  // Check when URL hash changes (email verification often uses hash fragments)
  useEffect(() => {
    const handleHashChange = async () => {
      // Wait a bit for auth state to potentially update
      setTimeout(async () => {
        if (currentUser && !loading) {
          const shouldShow = await shouldShowProfileCompletion(currentUser.id);
          if (shouldShow) {
            setTimeout(() => {
              openProfileCompletion();
            }, 500);
          }
        }
      }, 1000);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [currentUser, loading, shouldShowProfileCompletion, openProfileCompletion]);

  // Periodic check for auth state changes (every 2 seconds for first 30 seconds)
  useEffect(() => {
    let checkCount = 0;
    const maxChecks = 15; // 30 seconds total
    
    const interval = setInterval(async () => {
      checkCount++;
      
      if (currentUser && !loading) {
        const shouldShow = await shouldShowProfileCompletion(currentUser.id);
        if (shouldShow) {
          setTimeout(() => {
            openProfileCompletion();
          }, 500);
          clearInterval(interval);
          return;
        }
      }
      
      if (checkCount >= maxChecks) {
        clearInterval(interval);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []); // Only run once on mount

  // This component doesn't render anything
  return null;
};

export default ProfileCompletionWatcher;